import {useAnonUserSession} from '../components/useAnonUserSession';
import {useInitViewer, useViewer} from '../state/viewer/hooks';
import {useConsentAwareAnalyticsInjection} from '../util/consentAwareAnalyticSetup';
import {useDatadogUserSetup} from '../util/datadog/useDatadogUserSetup';

export const AppViewerLifecycle = () => {
  // Preserve the existing lifecycle order: consent setup first, viewer state
  // synchronization second, and Datadog user setup last.
  useConsentAwareAnalyticsInjection();
  useInitViewer();
  useDatadogUserSetup();
  // Stamp the anon_session_id here rather than in a header component so it
  // runs in both standalone and Forge shell mode (the shell omits SearchNav).
  useAnonUserSession(useViewer());
  return null;
};
